import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["ActiveMeasuringPoint"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getActiveMeasuringPoint: build.query<
        GetActiveMeasuringPointApiResponse,
        GetActiveMeasuringPointApiArg
      >({
        query: () => ({ url: `/ActiveMeasuringPoint` }),
        providesTags: ["ActiveMeasuringPoint"],
      }),
      postActiveMeasuringPointGet: build.query<
        PostActiveMeasuringPointGetApiResponse,
        PostActiveMeasuringPointGetApiArg
      >({
        query: (queryArg) => ({
          url: `/ActiveMeasuringPoint/Get`,
          method: "POST",
          body: queryArg,
        }),
        providesTags: ["ActiveMeasuringPoint"],
      }),
      putActiveMeasuringPointByName: build.mutation<
        PutActiveMeasuringPointByNameApiResponse,
        PutActiveMeasuringPointByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/ActiveMeasuringPoint/${queryArg.name}`,
          method: "PUT",
          body: queryArg.activeMeasuringPointDto,
        }),
        invalidatesTags: ["ActiveMeasuringPoint"],
      }),
      deleteActiveMeasuringPointByName: build.mutation<
        DeleteActiveMeasuringPointByNameApiResponse,
        DeleteActiveMeasuringPointByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/ActiveMeasuringPoint/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ActiveMeasuringPoint"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as activeMeasuringPointApi };
export type GetActiveMeasuringPointApiResponse =
  /** status 200 OK */ ActiveMeasuringPointDto[];
export type GetActiveMeasuringPointApiArg = void;
export type PostActiveMeasuringPointGetApiResponse = /** status 200 OK */ any[];
export type PostActiveMeasuringPointGetApiArg = string;
export type PutActiveMeasuringPointByNameApiResponse =
  /** status 200 OK */ void;
export type PutActiveMeasuringPointByNameApiArg = {
  name: string;
  activeMeasuringPointDto: ActiveMeasuringPointDto;
};
export type DeleteActiveMeasuringPointByNameApiResponse = unknown;
export type DeleteActiveMeasuringPointByNameApiArg = string;
export type ActiveMeasuringPointDto = {
  name: string;
  substation: string;
  switchgear: string;
  device: number;
  router?: number | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetActiveMeasuringPointQuery,
  useLazyGetActiveMeasuringPointQuery,
  usePostActiveMeasuringPointGetQuery,
  useLazyPostActiveMeasuringPointGetQuery,
  usePutActiveMeasuringPointByNameMutation,
  useDeleteActiveMeasuringPointByNameMutation,
} = injectedRtkApi;
